
export default function TeamSection() {
  const leadership = [
    {
      name: "Under Recruitment",
      position: "Director & Head Coach",
      credentials: "UEFA A License, Former MLS Player",
      image: "https://public.readdy.ai/ai/img_res/44afd9d2765a2b6000b7395af092a6da.jpg",
      description: "With over 15 years of professional playing experience and 10 years of coaching, Michael brings world-class expertise to NextZen."
    },
    {
      name: "Under Recruitment",
      position: "Youth Development Coordinator",
      credentials: "USSF B License, Sports Psychology Degree",
      image: "https://readdy.ai/api/search-image?query=Female%20soccer%20coach%20in%20her%2030s%2C%20energetic%20and%20professional%2C%20wearing%20soccer%20coaching%20attire%2C%20green%20soccer%20field%20background%2C%20confident%20sports%20professional%2C%20inspiring%20youth%20mentor&width=300&height=400&seq=coach-sarah&orientation=portrait",
      description: "Sarah specializes in youth development and creating age-appropriate training programs that maximize player potential."
    },
    {
      name: "Under Recruitment",
      position: "Technical Director",
      credentials: "USSF A License, Former College Coach",
      image: "https://readdy.ai/api/search-image?query=Experienced%20soccer%20coach%20in%20his%2050s%2C%20wise%20and%20professional%2C%20wearing%20coaching%20gear%2C%20soccer%20training%20facility%20background%2C%20authoritative%20sports%20professional%2C%20technical%20expertise&width=300&height=400&seq=coach-david&orientation=portrait",
      description: "David oversees our technical curriculum and ensures all programs meet the highest standards of soccer education."
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Leadership Team</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our experienced coaching staff brings together decades of playing and coaching experience to provide the best possible training for our players.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {leadership.map((member, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <img 
                src={member.image}
                alt={member.name}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-purple-600 font-medium mb-2">{member.position}</p>
                <p className="text-sm text-gray-600 mb-3">{member.credentials}</p>
                <p className="text-gray-700 text-sm leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">Our Coaching Philosophy</h3>
              <p className="text-gray-700 mb-4 leading-relaxed">
                We believe in developing the whole player – technically, tactically, physically, and mentally. Our coaching approach emphasizes:
              </p>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Individual skill development within team concepts
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Age-appropriate training methodologies
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Positive reinforcement and growth mindset
                </li>
                <li className="flex items-center">
                  <i className="ri-check-line text-green-500 mr-2"></i>
                  Character development through sport
                </li>
              </ul>
            </div>
            <div className="text-center">
              <div className="bg-purple-100 p-8 rounded-lg">
                <div className="text-4xl font-bold text-purple-600 mb-2">25+</div>
                <p className="text-gray-700 font-medium">Licensed Coaches</p>
                <div className="text-4xl font-bold text-purple-600 mb-2 mt-4">500+</div>
                <p className="text-gray-700 font-medium">Players Trained</p>
                <div className="text-4xl font-bold text-purple-600 mb-2 mt-4">15+</div>
                <p className="text-gray-700 font-medium">Championships Won</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
